export default __webpack_public_path__ + "static/media/logo.6b639d9e.png";